<template>
  <a
    :href="url"
    id="fab-button-wh"
    target='_blank'
    rel='noopener noreferrer'
    class='fab-button-whatsapp'
  >
    <img :src="require('../assets/whatsapp.svg')" alt='Whatsapp' />
  </a>
</template>

<script>
import getLanguage from '../utils/getLanguage';

  export default {
    name: "FabButtonWhatsApp",
    data() {
      return {
        language: '',
        url: '',
        messageBR: 'https://api.whatsapp.com/send?1=pt_BR&phone=557196518501&text=Ol%C3%A1,%20gostaria%20de%20saber%20como%20funcionam%20os%20atendimentos%20online',
        messagePT: 'https://api.whatsapp.com/send?phone=351926638181&text=Ol%C3%A1,%20tenho%20d%C3%BAvidas%20sobre%20como%20realizar%20consultas%20de%20Psicologia%20online'
      }
    },
    created() {
      this.language = getLanguage(window.location.href);
      this.url = this.language === 'pt' ? this.messagePT : this.messageBR
    }
  }
</script>